import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import SignOff from "./SignOff";


const SignOffDialog = ({open, onClose, data, resourceType}) => {

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth={true}
            maxWidth="md"
        >
            <DialogTitle>Sign off</DialogTitle>
            <DialogContent dividers={false}>
                <SignOff signOff={data} resourceType={resourceType} />
            </DialogContent>
            <DialogActions>
                <Button key="cancel" onClick={onClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    )
}

export default SignOffDialog;